if(typeof _GIRL_CONF['maggie']['game_memory']=='undefined'){_GIRL_CONF['maggie']['game_memory']={};};
_GIRL_CONF['maggie']['game_memory']['face']={left:571,top:160,width:118,height:132};
_GIRL_CONF['maggie']['game_memory']['hair']={left:483,top:30,width:242,height:449};
_GIRL_CONF['maggie']['game_memory']['hand']={left:459,top:305,width:363,height:352};
_GIRL_CONF['maggie']['game_memory']['item1']={left:233,top:263,width:228,height:438};
_GIRL_CONF['maggie']['game_memory']['item2']={left:870,top:408,width:146,height:293};
_GIRL_CONF['maggie']['game_memory']['tit1']={left:545,top:365,width:109,height:120};
_GIRL_CONF['maggie']['game_memory']['tit2']={left:642,top:373,width:87,height:102};
